import { getStaticDashboardConfig } from '@/hooks/useDashboardConfig';
import { IPairKey } from '@/store/models/encryption.model';
import { store } from '@/store/configuration';
import { parseAllKeys } from '@/utils/tools/parseAllKeys';
import { EncryptionService } from '@/services/encryption/EncryptionService';

export async function decryptData<T extends { metadata?: Record<string, string> }>(
  data: T,
  fieldsEncrypted: string,
  endUserId?: number,
): Promise<T> {
  const config = getStaticDashboardConfig();

  if (!config.api.encryption || !endUserId) {
    return data;
  }

  try {
    const endUserIdString = String(endUserId);
    const endUsersKeyPair = store.getState().encryption.endUsersKeyPair;

    let endUserKeyPair: IPairKey | undefined;

    const encryptionService = await EncryptionService.getInstance();

    if (endUsersKeyPair[endUserIdString]) endUserKeyPair = endUsersKeyPair[endUserIdString];
    else {
      endUserKeyPair = await encryptionService.decryptEndUserPrivateKey(endUserId);
    }

    if (!endUserKeyPair) return Promise.reject('End User Pair Key not stored');

    const result = await parseAllKeys(data as Record<string, unknown>, async (value, key) => {
      if (
        fieldsEncrypted
          .split(',')
          .map((field) => field.replace('operations.', ''))
          .includes(key as string)
      ) {
        try {
          value = await encryptionService.asymmetric.decryptData(
            value,
            endUserKeyPair?.publicKey as string,
            endUserKeyPair?.privateKey as string,
          );
        } catch (error) {
          console.error(error);
        }
      }
      return value;
    });

    return result as T;
  } catch (error) {
    console.error(error);
    return data;
  }
}
